import { useCallback, useEffect, useState } from "react";
import SidebarCheckbox from "./SidebarCheckbox";
import { useGetDepartmentListByOwnerId } from "repositories/staff-repository";

const SidebarDepartmentFilter = ({
  selectedId: selectedOwnerId,
  allFiltersRef,
  resetFilters,
  preSetter,
}) => {
  const [multiSelection, setMultiSelection] = useState(preSetter || []);
  const { data } = useGetDepartmentListByOwnerId(selectedOwnerId, {
    enabled: !!selectedOwnerId,
  });

  const handleChange = useCallback((e, item) => {
    setMultiSelection((prev) => {
      if (e.target.checked) {
        return [...prev, item.id];
      }
      return prev.filter((res) => res !== item.id);
    });
  }, []);
  useEffect(() => {
    const departmentIdsArray = allFiltersRef.current?.departmentIds;
    if (departmentIdsArray) {
      allFiltersRef.current.departmentIds = multiSelection;
    }
  }, [multiSelection]);
  useEffect(() => {
    if (resetFilters) {
      setMultiSelection([]);
    }
  }, [resetFilters]);
  return (
    <SidebarCheckbox
      checked={({ id }) => multiSelection.includes(id)}
      handleChange={handleChange}
      data={data || []}
      renderName={(item) => item.name}
    />
  );
};
export default SidebarDepartmentFilter;
